<script setup lang="ts">
import { useAppStore } from '@/stores/appStore'
import { useAuthStore } from '@/stores/authStore'
import { myRequest } from '@/utils/fetch'
import { ref, type Ref } from 'vue'
import { useRouter } from 'vue-router'

const { nextFn } = defineProps<{ nextFn: () => void }>()
export type gCalendarType = {
  id: string
  summary: string
  description: string
  timeZone: string
  readOnly: boolean
  etag: string
}

const router = useRouter()
const authstore = useAuthStore()
const appStore = useAppStore()
const calendars: Ref<gCalendarType[]> = ref([])
const loading = ref(false)
const open = ref(true)
const syncButtonStyle = nextFn !== undefined ? 'full-width' : ''
const selectedCalendars: Ref<gCalendarType[]> = ref([])

const fetchCalendars = async () => {
  loading.value = true
  calendars.value = await myRequest('GET', '/calendar/')
  const externalIDs = appStore.calendars.map((cal) => cal.externalID)
  selectedCalendars.value = calendars.value.filter((cal) => externalIDs.includes(cal.id))
  loading.value = false
}

const syncCalendar = async () => {
  loading.value = true
  await myRequest('POST', '/calendar/initialSync', selectedCalendars.value)
  loading.value = false
  if (nextFn) nextFn()
  else router.push('/onboarding/settings')
}

const logout = async () => {
  loading.value = true
  await myRequest('GET', '/auth/logout')
  authstore.logout()
  router.push('/')
  loading.value = false
}
// TODO move helper methods to somewhere else
// const stopHook = async () => {
//   loading.value = true
//   const webhookID = 'your-webhook-id'
//   const response = await fetch(`${import.meta.env.VITE_API_URL}/calendar/google/unsubscribe/${webhookID}`, {
//     credentials: 'include',
//     method: 'GET'
//   })
//   loading.value = false
// }

// const basicGet = async (path: 'test' | 'enrichData') => {
//   loading.value = true
//   const response = await fetch(`${import.meta.env.VITE_API_URL}/calendar/${path}`, {
//     credentials: 'include',
//     method: 'GET'
//   })
//   loading.value = false
// }

fetchCalendars()
</script>

<template>
  <q-dialog persistent v-model="open">
    <q-card class="vertical-middle myCard" bordered>
      <q-card-section>
        <transition appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
          <div :showing="calendars.length">
            <h6 class="text-h6">Select the calendars you want to sync</h6>
            <q-separator dark class="q-mb-md" />
            <q-item tag="label" v-ripple v-for="cal in calendars" :key="cal.id">
              <q-item-section side top>
                <q-checkbox v-model="selectedCalendars" :val="cal" />
              </q-item-section>

              <q-item-section>
                <q-item-label>{{ cal.summary }}</q-item-label>
                <q-item-label caption>
                  {{ cal.description }}
                </q-item-label>
              </q-item-section>
            </q-item>

            <q-separator dark class="q-mb-md" />

            <div class="row justify-between">
              <q-btn v-if="!nextFn" color="accent" label="Logout" @click="logout" />
              <q-btn color="secondary" label="Sync" @click="syncCalendar" :class="syncButtonStyle" />
            </div>

            <!-- <q-btn color="primary" label="StopHook" @click="stopHook" />
          <q-btn color="primary" label="Enrich" @click="() => basicGet('enrichData')" />
          <q-btn color="primary" label="Test" @click="() => basicGet('test')" />
          <a href="/onboarding/settings"><q-btn color="primary" label="Settings" /></a> -->
          </div>
        </transition>
      </q-card-section>

      <q-inner-loading :showing="loading">
        <q-spinner-gears size="50px" color="primary" />
      </q-inner-loading>
    </q-card>
  </q-dialog>
</template>
